module.exports = __webpack_public_path__ + "img/bank-04-kb.0cd1fab2.svg";